/* ---------------------------------------

    -- news JSON取得して生成

--------------------------------------- */
export default class  NewsManager {
    constructor() {


        this.$container = $("#p-about-content-news");

    }
    init(){

        let _this = this;
        $.getJSON("./assets/news.json", function(data) {
            let i = 0;
            let _List = [];
            for ( i = 0; i < 3; i++ ) {
                if($(data)[i]['show']!=="1") return;
                if($(data)[i]['link'] !== ''){
                    _List[i] = '<article class="news js__show__inner"><a href="'+$(data)[i]['link']+'" target="_blank"><time>'+$(data)[i]['date']+'</time><p class="text">'+$(data)[i]['content'].slice(0,20)+'</p></a></article>';
                    _this.$container.append(_List[i]);
                }else{
                    _List[i] = '<article class="news js__show__inner"><time>'+$(data)[i]['date']+'</time><p class="text">'+$(data)[i]['content'].slice(0,20)+'</p></article>';
                    _this.$container.append(_List[i]);
                }
            }
        });


    }
}